import { IJsonMetaData, jsonMetadataKey } from './IJsonMetaData';
import "reflect-metadata";

export class MapUtilsGlobalService {

    static getClassType(target: any, propertyKey: string): any {
        return Reflect.getMetadata("design:type", target, propertyKey)
    }

    static getJsonProperty<T>(target: any, propertyKey: string): IJsonMetaData<T> {
        return Reflect.getMetadata(jsonMetadataKey, target, propertyKey);
    }

    static isNativo(type) {
        switch (type) {
            case Date:
            case Number:
            case Boolean:
            case String:
                return true;
        }

        return false;
    }

    static manageNativeType(type, param: any): Object {
        switch (type) {
            case String: return new String(param);
            case Number: return new Number(param); // java date?
            case Date: return param==null ? 'null' : new Date(param.year + 1900, param.month, param.date);
            case Boolean: return new Boolean(param);
        }

        return undefined;
    }

    static isArray(object) {
        if(object === Array) {
            return true;
        }
        else if(typeof Array.isArray === "function") {
            return Array.isArray(object);
        }
        else {
            return !!(object instanceof Array);
        }
    }

    static deserialize<T>(classType: any, jsonObject) {
        let obj = new classType.constructor();
        if((classType===undefined) || (jsonObject===undefined)) return obj;

        if(Object.keys(obj).length > 0) {
            Object.keys(obj).forEach((key) => {
                let propertyMetadataFn: (IJsonMetaData) => any = (propertyMetadata) => {
                    let propertyName = propertyMetadata.name || key;
                    let innerJson = jsonObject ? jsonObject[propertyName] : undefined;
                    let classType = MapUtilsGlobalService.getClassType(obj, key);
                    if(MapUtilsGlobalService.isArray(classType)) {
                        let metadata = MapUtilsGlobalService.getJsonProperty(obj, key);
                        if(metadata.classType.prototype || MapUtilsGlobalService.isNativo(classType)) {
                            if(innerJson && MapUtilsGlobalService.isArray(innerJson)) {
                                return innerJson.map(
                                    (item) => MapUtilsGlobalService.deserialize(metadata.classType.prototype, item)
                                );
                            }
                            else {
                                return undefined;
                            }
                        }
                        else {
                            return innerJson;
                        }
                    }
                    else if(!MapUtilsGlobalService.isNativo(classType.prototype)) {
                        return MapUtilsGlobalService.deserialize(classType.prototype, innerJson);
                    }
                    else {
                        return jsonObject ? jsonObject[propertyName] : undefined;
                    }
                };

                let propertyMetadata = MapUtilsGlobalService.getJsonProperty(obj, key);
                if(propertyMetadata) {
                    if(MapUtilsGlobalService.isNativo(propertyMetadata.classType)) {
                        obj[key] = MapUtilsGlobalService.manageNativeType(propertyMetadata.classType, propertyMetadataFn(propertyMetadata));
                    }
                    else {
                        obj[key] = propertyMetadataFn(propertyMetadata);
                    }
                }
                else {
                    if(jsonObject && jsonObject[key]!==undefined) {
                        obj[key] = jsonObject[key];
                    }
                }
            });
        }
        else {
            obj = jsonObject;
        }

        return obj;
    }

}